(() => {
  const emojiContainer = document.querySelector('.gutenbrain-dialog__rain__animate');
  const emoji = ['🎉', '🧠', '🎊'];
  const circles = [];

  function Circle(x, y, c, v, range) {
    const This = this;
    this.x = x;
    this.y = y;
    this.color = c;
    this.v = v;
    this.range = range;
    this.element = document.createElement('span');
    this.element.style.opacity = 0;
    this.element.style.display = 'block';
    this.element.style.position = 'absolute';
    this.element.style.fontSize = '42px';
    this.element.style.color = `hsl(${(Math.random() * 360 | 0)}, 80%, 50%)`;
    this.element.innerHTML = c;
    emojiContainer.appendChild(this.element);

    this.update = () => {
      if (This.y > 1200) {
        This.y = 80 + (Math.random() * 4);
        This.x = This.range[0] + (Math.random() * This.range[1]);
      }
      This.y += This.v.y;
      This.x += This.v.x;
      this.element.style.opacity = 1;
      this.element.style.transform = `translate3d(${This.x}px, ${This.y}px, 0px)`;
      this.element.style.webkitTransform = `translate3d(${This.x}px, ${This.y}px, 0px)`;
      this.element.style.mozTransform = `translate3d(${This.x}px, ${This.y}px, 0px)`;
    };
  }

  function addCircle(delay, range, color) {
    setTimeout(() => {
      const c = new Circle(range[0] + (Math.random() * range[1]), 80 + (Math.random() * 4), color, {
        x: -0.15 + (Math.random() * 0.3),
        y: 1 + (Math.random() * 1),
      }, range);
      circles.push(c);
    }, delay);
  }

  function animate() {
    for (let i = 0; i < circles.length; i++) {
      circles[i].update();
    }
    requestAnimationFrame(animate);
  }

  const openModalBtns = document.querySelectorAll('.js--open-modal');
  const closeModalBtns = document.querySelectorAll('.js--close-modal');

  for (let i = 0; i < openModalBtns.length; i++) {
    const openBtn = openModalBtns[i];
    openBtn.addEventListener('click', () => {
      document.body.classList.add('is-modal');
      for (let index = 0; index < 15; index++) {
        addCircle(index * 150, [10 + 0, 300], emoji[Math.floor(Math.random() * emoji.length)]);
        addCircle(index * 150, [10 + 0, -300], emoji[Math.floor(Math.random() * emoji.length)]);
        addCircle(index * 150, [10 - 200, -300], emoji[Math.floor(Math.random() * emoji.length)]);
        addCircle(index * 150, [10 + 200, 300], emoji[Math.floor(Math.random() * emoji.length)]);
        addCircle(index * 150, [10 - 400, -300], emoji[Math.floor(Math.random() * emoji.length)]);
        addCircle(index * 150, [10 + 400, 300], emoji[Math.floor(Math.random() * emoji.length)]);
        addCircle(index * 150, [10 - 600, -300], emoji[Math.floor(Math.random() * emoji.length)]);
        addCircle(index * 150, [10 + 600, 300], emoji[Math.floor(Math.random() * emoji.length)]);
      }
      animate();
    });
  }

  for (let i = 0; i < closeModalBtns.length; i++) {
    const closeBtn = closeModalBtns[i];
    closeBtn.addEventListener('click', () => {
      document.body.classList.remove('is-modal');
      emojiContainer.innerHTML = '';
    });
  }
})();
